import React, { useState } from 'react';
import { Button, Box, Typography, Input, useTheme } from '@mui/material';

interface ChoosePdfButtonProps {
  onFileSelect: (file: File | null, message?: string) => void;
}

const ChoosePdfButton = ({ onFileSelect }: ChoosePdfButtonProps) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const theme = useTheme();

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;

    if (file) {
      // Check if the file is a PDF
      const fileExtension = file.name.split('.').pop()?.toLowerCase();

      if (fileExtension === 'pdf') {
        setErrorMessage(null); // Clear any previous errors
        onFileSelect(file); // Pass valid file to parent component
      } else {
        const message = 'Current capsule intake accepts PDF files only.';
        setErrorMessage(message);
        onFileSelect(null, message); // Pass error message to parent component
      }
    }
  };

  return (
    <Box textAlign="center">
      <Button
        variant="contained"
        component="label"
        sx={{
          backgroundColor: theme.palette.primary.main,
          '&:hover': {
            backgroundColor: theme.palette.primary.dark,
          },
        }}
      >
        Upload Capsule PDF
        <Input
          type="file"
          inputProps={{ accept: '.pdf' }} // Restrict file selection to PDFs
          onChange={handleFileChange}
          sx={{ display: 'none' }} // Hide the actual input element
        />
      </Button>
      {errorMessage && (
        <Typography color="error" variant="body2" sx={{ marginTop: 1 }}>
          {errorMessage}
        </Typography>
      )}
    </Box>
  );
};

export default ChoosePdfButton;
